export default __webpack_public_path__ + "static/media/VideoThumbnail6.1f862c9f.svg";